module.exports = __webpack_public_path__ + "img/brand10.3fb9aaec.png";